import type { JSX } from 'react';
import { Button } from '@mui/material';

import s from './PrimaryButton.module.css';

type PrimaryButtonProps = {
  title: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  customClass?: string;
  icon?: JSX.Element;
  onClick: () => void;
};

function PrimaryButton({
  title,
  isDisabled,
  isLoading,
  customClass,
  icon,
  onClick,
}: PrimaryButtonProps) {
  return (
    <Button
      variant="contained"
      disabled={isDisabled || isLoading}
      loading={isLoading}
      className={`${s.primaryButton} ${icon ? s.icon : ''} ${customClass || ''}`}
      onClick={onClick}>
      {icon && icon}
      <p className={s.buttonText}>{title}</p>
    </Button>
  );
}

export default PrimaryButton;
